import { DateRange } from 'react-day-picker';

import { DateRangeString } from '@/lib/types';
import { Coach } from '@addmile/backend-client';

export const spongeBobCoachId = '7390cad6-3f80-4f9d-8c40-fe9627e06b09';

export const prepareDateRange = (dateRange: DateRange | null): DateRangeString => {
  if (dateRange?.from && dateRange?.to) {
    return {
      from: dateRange.from.toISOString(),
      to: dateRange.to.toISOString(),
    };
  }

  return {
    from: undefined,
    to: undefined,
  };
};

export const getDefaultCoaches = (coaches: Coach[]): string[] => {
  return coaches?.filter((coach) => coach.id !== spongeBobCoachId).map((coach) => coach.id);
};
